import { ExternalLink } from 'lucide-react';

const AMAZON_AFFILIATE_URL = "https://www.amazon.com?&linkCode=ll2&tag=buildbrandos-20&linkId=2f94384999608b539bf53dbbc586c6ac&language=en_US&ref_=as_li_ss_tl";

export const AMAZON_LINK = AMAZON_AFFILIATE_URL;
export const AMAZON_SHORT_LINK = "https://amzn.to/470uLNO";
export const AMAZON_TAG = "buildbrandos-20";

export function AffiliateDisclosure({ className = "" }) {
  return (
    <div className={`text-[10px] leading-relaxed text-gray-400 ${className}`} data-testid="affiliate-disclosure">
      <p>
        <strong className="text-gray-500">Affiliate Disclosure:</strong> Brand OS is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com. When you click on product links and make a purchase, we may earn a small commission at no additional cost to you. Amazon and the Amazon logo are trademarks of Amazon.com, Inc. or its affiliates. All product orders are fulfilled by Amazon — Brand OS does not sell, ship, or handle any physical products.
      </p>
    </div>
  );
}

export function AffiliateFooter() {
  return (
    <div className="border-t border-gray-100 dark:border-white/10 py-4 px-6" data-testid="affiliate-footer">
      <div className="max-w-4xl mx-auto">
        <AffiliateDisclosure />
      </div>
    </div>
  );
}

export function AmazonProductBox({ productName, description, className = "" }) {
  return (
    <div className={`flex items-center gap-3 bg-gray-50 dark:bg-white/5 border border-gray-100 dark:border-white/10 rounded-xl p-3 ${className}`} data-testid={`amazon-product-box`}>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{productName}</p>
        {description && <p className="text-[11px] text-gray-400 truncate">{description}</p>}
      </div>
      <a
        href={AMAZON_AFFILIATE_URL}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="flex items-center gap-1.5 px-3 py-2 bg-[#FF9900] text-white text-xs font-semibold rounded-lg hover:bg-[#e88b00] flex-shrink-0 whitespace-nowrap"
        style={{ transition: 'background-color 0.2s' }}
        data-testid="amazon-check-price-btn"
      >
        <ExternalLink className="w-3 h-3" strokeWidth={2} />
        Check Price on Amazon
      </a>
    </div>
  );
}

export function AmazonCTAButton({ text = "Check Prices on Amazon", className = "" }) {
  return (
    <a
      href={AMAZON_AFFILIATE_URL}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`inline-flex items-center gap-2 px-5 py-2.5 bg-[#FF9900] text-white text-sm font-semibold rounded-xl hover:bg-[#e88b00] shadow-sm ${className}`}
      style={{ transition: 'background-color 0.2s' }}
      data-testid="amazon-cta-btn"
    >
      <ExternalLink className="w-4 h-4" strokeWidth={2} />
      {text}
    </a>
  );
}

export default AffiliateFooter;
